import React from "react";

import type { Sponsoring } from "../types";

const SponsoringList = React.lazy(() => import("./SponsoringList"));

export default {
  list: SponsoringList,
  // A sponsoring has no name of its own (its title is the company name)
  recordRepresentation: (record: Sponsoring) => `#${record.id}`,
};
